var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{attrs:{"title":"Request","hasQuickActionBar":false,"isFullWidth":true}},[_c('ThirdPartyAcceptInvitation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }